import { template } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
export interface Signature {
    Args: {
        class?: string;
    };
    Element: SVGElement;
}
const WrIndicatiorIconComponent: TemplateOnlyComponent<Signature> = template(`
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <circle cx='8' cy='8' r='4' fill='currentColor' />
  </svg>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default WrIndicatiorIconComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3NlbWVpYS9wYWNrYWdlcy9lbWJlci1hZGRvbnMvdjIvZW1iZXItd2lzZXIvc3JjL2NvbXBvbmVudHMvd3IvaWNvbnMvaW5kaWNhdG9yLmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFRlbXBsYXRlT25seUNvbXBvbmVudCB9IGZyb20gJ0BlbWJlci9jb21wb25lbnQvdGVtcGxhdGUtb25seSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgU2lnbmF0dXJlIHtcbiAgQXJnczoge1xuICAgIGNsYXNzPzogc3RyaW5nO1xuICB9O1xuICBFbGVtZW50OiBTVkdFbGVtZW50O1xufVxuXG5jb25zdCBXckluZGljYXRpb3JJY29uQ29tcG9uZW50OiBUZW1wbGF0ZU9ubHlDb21wb25lbnQ8U2lnbmF0dXJlPiA9IDx0ZW1wbGF0ZT5cbiAgPHN2Z1xuICAgIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZydcbiAgICB3aWR0aD0nMTYnXG4gICAgaGVpZ2h0PScxNidcbiAgICB2aWV3Qm94PScwIDAgMTYgMTYnXG4gICAgZmlsbD0nbm9uZSdcbiAgICBjbGFzcz17e0BjbGFzc319XG4gICAgLi4uYXR0cmlidXRlc1xuICA-XG4gICAgPGNpcmNsZSBjeD0nOCcgY3k9JzgnIHI9JzQnIGZpbGw9J2N1cnJlbnRDb2xvcicgLz5cbiAgPC9zdmc-XG48L3RlbXBsYXRlPjtcblxuZXhwb3J0IGRlZmF1bHQgV3JJbmRpY2F0aW9ySWNvbkNvbXBvbmVudDtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsY0FBYyxxQkFBcUIsUUFBUSxpQ0FBaUM7QUFFNUUsaUJBQWlCO0lBQ2Y7UUFDRSxRQUFRLE1BQU07O0lBRWhCLFNBQVM7O0FBR1gsTUFBTSwyQkFBMkIsc0JBQXNCLGFBQWEsU0FBVSxDQUFBOzs7Ozs7Ozs7Ozs7QUFZOUUsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBO0FBRVYsZUFBZSwwQkFBMEIifQ